import React from 'react';
import { Input as FormInput } from '@ds/react-components';
import classNames from 'classnames';

const SuspensionFeeTxt = (props) => {
  const { classes, register, errors, disabled = false } = props;
  const maxSuspensionFee = 999999.99;

  return (
    <div
      className={classNames(classes.FormItem, {
        [classes.FormItemDisableBorder]: disabled,
      })}>
      <fieldset disabled={disabled}>
        <FormInput
          className={classes.Input}
          label="Suspension fee (Weekly)"
          startAdornment="$"
          name="suspensionFee"
          inputRef={register({
            validate: {
              max: (value) =>
                parseFloat(value) <= maxSuspensionFee ||
                `Suspension fee cannot exceed ${maxSuspensionFee}`,
            },
          })}
          type="number"
          error={errors.suspensionFee && errors.suspensionFee.message}
          step=".01"></FormInput>
      </fieldset>
    </div>
  );
};

export default SuspensionFeeTxt;
